export default __webpack_public_path__ + "static/media/newLogo.1a19e305.png";